const COMMUNICATION_DIRECTION = ['Incoming', 'Outgoing'] as const;

export default COMMUNICATION_DIRECTION;
